import React from 'react'
import styles from './add-to-group.styles'
import injectSheet from 'react-jss'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import GroupsSelect from '../groups-select/groups-select.container'
import { Formik } from 'formik'

const AddToGroup = ({
  classes,
  opened,
  requestClose = () => null,
  onSubmit,
  title,
  except,
  allGroups
}) => (
  <Modal isOpen={opened}>
    <ModalHeader>{title}</ModalHeader>
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        group: ''
      }}>
      {props => {
        const {
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          isValid
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy className={classes.modalContent}>
              {!allGroups && (
                <GroupsSelect
                  except={except}
                  selectOption="Select a group"
                  whenNoGroupsAvailable={
                    <span>You can't add this pupil to any more groups</span>
                  }
                  formSelectProps={{
                    value: values.group,
                    name: 'group',
                    onChange: handleChange,
                    onBlur: handleBlur
                  }}
                />
              )}
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button
                simple
                tall
                className={classes.cancel}
                action={requestClose}>
                Cancel
              </Button>
              <Button disabled={!isValid} tall type="submit">
                Add to a group
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(AddToGroup)
